import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface EpgDialogData {
    btnCancelText: string | null;
    btnOkText: string;
    message: string[];
    title: string;
    btnOkHidden?: boolean;
    btnOkColor?: 'primary' | 'accent' | 'warn';
    dialogSize?: 'sm' | 'md' | 'lg';
}

@Component({
    selector: 'app-epg-dialog',
    templateUrl: './epg-dialog.component.html',
    styleUrls: ['./epg-dialog.component.scss']
})
export class EpgDialogComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: EpgDialogData,
        private dialogRef: MatDialogRef<EpgDialogComponent>
    ) { }

    ngOnInit(): void {
    }

    close() { 
        this.dialogRef.close(false)
    }
    confirm() {
        this.dialogRef.close(true)
     }

}
